/*
* @Author: zhangzhitao
* @Date: 2019-06-10 14:58:51
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-06-10 15:09:14
*/

<template>
  <div
    class="container home-page"
    :class="{ 'is-overdue': overdueFlag }"
  >
    <div
      v-for="(item, index) in arrList"
      :key="index"
      :style="
          `position:absolute;width:${item.width}%;height:${item.height}%;left:${
            item.xPos
          }%;top:${item.yPos}%;`
        "
    >
      <div
        class="m-widget-box"
        v-if="item.showTitleBar"
        :style="item.borderStyle + item.marginStyle"
      >
        <div
          class="u-parts-head"
          v-if="item.showTitleBar"
          :style="item.titleBarStyle"
        >
          {{ item.title }}
          <span
            @click="moreOpen(item)"
            class="u-more"
            v-if="item.showMore"
          >{{ $t("management.home.more_label") }}></span>
        </div>
        <widget-homepage
          ref="widgetRef"
          :comType="item.type"
          :comSubType="item.subType"
          :widgetId="item.id"
          :refreshPeriod="item.refreshPeriod"
          :url="item.fullUrl"
        ></widget-homepage>
      </div>
      <widget-homepage
        ref="widgetRef"
        v-if="!item.showTitleBar"
        :style="item.borderStyle + item.marginStyle"
        :comType="item.type"
        :comSubType="item.subType"
        :widgetId="item.id"
        :refreshPeriod="item.refreshPeriod"
        :url="item.fullUrl"
      ></widget-homepage>
    </div>
  </div>
</template>

<script>
import widgetHomepage from 'components/widget-homepage/widget-homepage.vue'
export default {
  name: 'full-screen',
  props: {
    overdueFlag: {
      type: Boolean,
      default: false
    },
    arrList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },

  components: { widgetHomepage },

  computed: {},

  mounted () { },

  methods: {}
}

</script>

<style lang="less" scoped>
</style>
